import React, { useState } from 'react';
import { X as XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-dark py-10 px-4 text-center" data-id="element-80">
        <div className="max-w-content mx-auto" data-id="element-81">
          <p className="text-brand-bg/80 text-sm mb-6" data-id="element-82">
            © {new Date().getFullYear()} Closet Flaco Express. Todos los
            derechos reservados.
          </p>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 mb-8 text-sm" data-id="element-83">
            <button onClick={() => setActiveModal('privacy')} className="text-brand-accent hover:text-brand-accent/80 transition-colors cursor-pointer" data-id="element-84">
              Política de Privacidad
            </button>
            <span className="text-brand-bg/30" data-id="element-85">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-brand-accent hover:text-brand-accent/80 transition-colors cursor-pointer" data-id="element-86">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-brand-bg/40 text-xs max-w-lg mx-auto leading-relaxed" data-id="element-87">
            Este producto es para fines educativos e informativos. Los
            resultados varían según cada persona.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-88">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-89">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl w-full max-w-lg max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-90">
              <div className="sticky top-0 bg-white border-b border-brand-text/10 px-6 py-4 flex items-center justify-between rounded-t-2xl z-10" data-id="element-91">
                <h3 className="font-serif font-bold text-brand-text text-xl" data-id="element-92">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-1.5 rounded-full hover:bg-brand-text/5 transition-colors" aria-label="Cerrar" data-id="element-93">
                  <XIcon className="w-5 h-5 text-brand-text/60" data-id="element-94" />
                </button>
              </div>

              <div className="px-6 py-6 text-brand-text/80 text-sm leading-relaxed space-y-4" data-id="element-95">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-96" /> : <TermsContent data-id="element-97" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-brand-text/50" data-id="element-98">
        Última actualización: mayo 2025
      </p>

      <h4 className="font-bold text-brand-text text-base mt-2" data-id="element-99">
        1. Información que recopilamos
      </h4>
      <p data-id="element-100">
        Al realizar una compra en Closet Flaco Express, recopilamos únicamente
        la información necesaria para procesar tu pedido: nombre, dirección de
        correo electrónico y datos de pago. Los datos de pago son procesados de
        forma segura por nuestros proveedores de pago (Stripe, PayPal) y nunca
        almacenamos información de tarjetas de crédito en nuestros servidores.
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-101">
        2. Uso de la información
      </h4>
      <p data-id="element-102">Utilizamos tu información personal exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-103">
        <li data-id="element-104">Procesar y entregar tu compra digital</li>
        <li data-id="element-105">Enviarte el enlace de descarga del producto</li>
        <li data-id="element-106">Comunicarnos contigo en caso de problemas con tu pedido</li>
        <li data-id="element-107">
          Gestionar solicitudes de reembolso dentro del período de garantía
        </li>
      </ul>

      <h4 className="font-bold text-brand-text text-base" data-id="element-108">
        3. Protección de datos
      </h4>
      <p data-id="element-109">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Toda la comunicación se realiza
        mediante conexiones cifradas (SSL/TLS).
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-110">
        4. Compartir información
      </h4>
      <p data-id="element-111">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a los proveedores de servicios de pago necesarios para
        procesar tu transacción.
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-112">5. Cookies</h4>
      <p data-id="element-113">
        Nuestro sitio puede utilizar cookies esenciales para el funcionamiento
        básico de la página y cookies analíticas para comprender cómo los
        visitantes interactúan con el sitio. Puedes desactivar las cookies en la
        configuración de tu navegador.
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-114">6. Tus derechos</h4>
      <p data-id="element-115">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. También puedes solicitar la portabilidad de tus
        datos o retirar tu consentimiento para el procesamiento de los mismos.
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-116">
        7. Cambios en esta política
      </h4>
      <p data-id="element-117">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de última actualización.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-brand-text/50" data-id="element-118">
        Última actualización: mayo 2025
      </p>

      <h4 className="font-bold text-brand-text text-base mt-2" data-id="element-119">
        1. Descripción del producto
      </h4>
      <p data-id="element-120">
        Closet Flaco Express es un producto digital en formato PDF que contiene
        información educativa sobre técnicas de estilismo visual. Al completar
        tu compra, recibirás acceso inmediato para descargar el archivo digital.
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-121">2. Precio y pago</h4>
      <p data-id="element-122">
        El precio del producto es de $8,99 USD (pago único). No se trata de una
        suscripción ni se realizarán cargos recurrentes. El pago se procesa de
        forma segura a través de plataformas de pago certificadas.
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-123">
        3. Entrega del producto
      </h4>
      <p data-id="element-124">
        Al completar el pago, recibirás acceso inmediato al archivo PDF a través
        de un enlace de descarga. Es tu responsabilidad guardar el archivo en un
        lugar seguro. No se realizan envíos físicos.
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-125">
        4. Garantía de devolución
      </h4>
      <p data-id="element-126">
        Ofrecemos una garantía de satisfacción de 7 días calendario a partir de
        la fecha de compra. Si no estás satisfecha con el producto, puedes
        solicitar un reembolso completo dentro de ese período sin necesidad de
        justificación. Los reembolsos se procesarán por el mismo método de pago
        utilizado en la compra.
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-127">
        5. Propiedad intelectual
      </h4>
      <p data-id="element-128">
        Todo el contenido de Closet Flaco Express, incluyendo textos, imágenes,
        diagramas y diseño, está protegido por derechos de autor. La compra
        otorga una licencia de uso personal e intransferible. Queda prohibida la
        reproducción, distribución, reventa o compartición del material sin
        autorización expresa.
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-129">
        6. Limitación de responsabilidad
      </h4>
      <p data-id="element-130">
        Closet Flaco Express es un producto educativo e informativo. Los
        resultados pueden variar según cada persona. No garantizamos resultados
        específicos. El contenido no sustituye el asesoramiento profesional de
        un estilista certificado.
      </p>

      <h4 className="font-bold text-brand-text text-base" data-id="element-131">7. Modificaciones</h4>
      <p data-id="element-132">
        Nos reservamos el derecho de modificar estos términos y condiciones en
        cualquier momento. Las modificaciones entrarán en vigor desde su
        publicación en esta página. El uso continuado del producto después de
        dichas modificaciones constituye la aceptación de los nuevos términos.
      </p>
    </>;
}